module.exports = __webpack_public_path__ + "img/icon-check.0a29e0ac.svg";